import { createRouter, createWebHistory } from "vue-router";

// *******后台路由部分********************************************************
// 补充修改后台路由
const routes = [
  // 目的是让后台路由都包含/admin
  {
    path: "/admin",
    name: "后台",
    component: () => import("../layout/index.vue"),
    redirect: "/admin/index",
    children: [
      {
        path: "index",
        name: "首页",
        component: () => import("../views/index/index.vue"),
      },
      {
        path: "userCenter",
        name: "个人中心",
        component: () => import("../views/userCenter/index.vue"),
      },
    ],
  },

  // *******前台路由部分********************************************************
  {
    path: "/",
    name: "前台官网",
    redirect: "/webpage/home",
    component: () => import("../views/webpage/webpageApp.vue"),
  },

  {
    path: "/webpage",
    name: "PageView",
    redirect: "/webpage/home",
    component: () => import("../views/webpage/webpageApp.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Login.vue"),
      },
      {
        path: "home",
        name: "Home",
        component: () => import("../views/webpage/HomePage.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "Product",
        name: "Product",
        component: () => import("../views/webpage/Product.vue"),
        redirect: "consulting",
        meta: {
          title: "产品信息",
        },
        children: [
          {
            path: "consulting",
            name: "productConsulting",
            component: () =>
              import("../views/webpage/Product_consulting.vue"),
            meta: { title: "产品信息丨企业信息化管理咨询" },
          },
          {
            path: "erp",
            name: "productErp",
            component: () => import("../views/webpage/Product_erp.vue"),
            meta: { title: "产品信息丨企业信息化管理软件" },
          },
          {
            path: "iotData",
            name: "iotData",
            component: () => import("../views/webpage/Product_iotData.vue"),
            meta: { title: "产品信息丨工业互联网数据平台" },
          },
          {
            path: "video",
            name: "productVideo",
            component: () => import("../views/webpage/Product_video.vue"),
            meta: { title: "产品信息丨视频管理平台" },
          },
          {
            path: "lims",
            name: "productLims",
            component: () => import("../views/webpage/Product_lims.vue"),
            meta: { title: "产品信息丨水质检验 LIMS" },
          },
          {
            path: "iotHardware",
            name: "iotHardware",
            component: () =>
              import("../views/webpage/Product_iotHardware.vue"),
            meta: { title: "产品信息丨物联网智能硬件" },
          },
          {
            path: "aiLocal",
            name: "productAiLocal",
            component: () => import("../views/webpage/Product_aiLocal.vue"),
            meta: { title: "产品信息丨AI 本地化应用" },
          },
        ],
      },
      {
        path: "service",
        name: "service",
        component: () => import("../views/webpage/Service.vue"),
        props: true,
        meta: {
          title: "主营业务",
        },
      },
      {
        path: "servicedetail",
        name: "serviceDetail",
        component: () => import("../views/webpage/ServiceDetail.vue"),
        props: true,
        meta: {
          title: "主营业务",
        },
      },
      {
        path: "productdevelop",
        name: "productdevelop",
        component: () => import("../views/webpage/productdevelop.vue"),
        meta: {
          title: "研发动态",
        },
      },
      {
        path: "companyintroduction",
        name: "companyIntroduction",
        component: () => import("../views/webpage/CompanyIntroduction.vue"),
        meta: {
          title: "公司简介",
        },
      },
      {
        path: "jobchance",
        name: "jobChance",
        component: () => import("../views/webpage/JobChance.vue"),
        meta: {
          title: "工作意向",
        },
      },
      {
        path: "software-trial",
        name: "softwareTrial",
        component: () => import("../views/webpage/SoftwareTrial.vue"),
        meta: {
          title: "软件试用",
        },
      },
      {
        path: "param-tracker-app",
        name: "paramTrackerAppIntro",
        component: () => import("../views/webpage/ParamTrackerAppIntro.vue"),
        meta: {
          title: "指标随手记 App",
        },
      },
      {
        path: "ai-local-kb",
        name: "aiLocalKbIntro",
        component: () => import("../views/webpage/AiLocalKbIntro.vue"),
        meta: {
          title: "软件项目 AI 接入",
        },
      },
      {
        path: "solution-arch/:product",
        name: "solutionArchitecture",
        component: () => import("../views/webpage/SolutionArchitecture.vue"),
        meta: {
          title: "技术方案与架构",
        },
      },
      // {
      //   path: "contactus",
      //   name: "contactUs",
      //   component: () => import("../views/webpage/ContactUs.vue"),
      //   meta: {
      //     title: "联系我们",
      //   },
      // },
    ],
  },
  // 404 路由
  {
    path: "/:pathMatch(.*)*", // 匹配所有其他路径
    name: "NotFound",
    component: () => import("../views/404.vue"), // 404 组件
  },
];








// webhistory形式 去掉原有的url中的#
const router = createRouter({
  history: createWebHistory(), // 改为 createWebHistory
  routes,
});

export default router;
